import {
  ESAReportAttributes,
  ESAReportEntry,
  FileType,
  OccupancyAndUtilizationExportable,
} from 'spw-redux/modules/reports/types';
import { Clip, Report, ReportRequest } from '../Report';

export default class OccupancyAndUtilizationReport implements Report {
  projectId: number;

  exportableType: OccupancyAndUtilizationExportable;

  category?: string;

  roundIds: number[];

  buildingIds: number[];

  floorIds: number[];

  roundsWithLowestOccupancy: number[] = [];

  roundsWithHighestOccupancy: number[] = [];

  shouldShowClientFacingNames: boolean;

  format: FileType;

  constructor(attributes: ESAReportAttributes) {
    this.projectId = attributes.project.id;
    this.exportableType = attributes.exportableType as OccupancyAndUtilizationExportable;
    this.category = attributes.category;
    this.roundIds = attributes.roundIds;
    this.buildingIds = attributes.buildingIds;
    this.floorIds = attributes.floorIds;
    this.roundsWithLowestOccupancy = attributes.roundsWithLowestOccupancy;
    this.roundsWithHighestOccupancy = attributes.roundsWithHighestOccupancy;
    this.shouldShowClientFacingNames = attributes.shouldShowClientFacingNames;
    this.format = attributes.format;
  }

  getReportRequest(): ReportRequest {
    const reportEntries = [
      {
        cardType: 'Spaces Occupancy Summary',
        clip: { x: 0, y: 0, width: 1020, height: 254 },
      },
      {
        cardType: 'Unobserved Spaces',
        clip: { x: 0, y: 0, width: 340, height: 249 },
      },
      {
        cardType: 'Average Occupancy',
        clip: { x: 0, y: 0, width: 340, height: 249 },
      },
      {
        cardType: 'Seats Utilization Summary',
        clip: { x: 0, y: 0, width: 1020, height: 278 },
      },
      {
        cardType: 'Unobserved Seats',
        clip: { x: 0, y: 0, width: 340, height: 249 },
      },
      {
        cardType: 'Average Seat Utilization',
        clip: { x: 0, y: 0, width: 340, height: 249 },
      },
      {
        cardType: 'Average Seats Used Per Space',
        clip: { x: 0, y: 0, width: 340, height: 249 },
      },
      ...this.roundsWithLowestOccupancy?.map((roundId) => ({
        cardType: 'Lowest Occupancy',
        clip: { x: 0, y: 0, width: 340, height: 249 },
        params: { roundId },
      })),
      ...this.roundsWithHighestOccupancy?.map((roundId) => ({
        cardType: 'Highest Occupancy',
        clip: { x: 0, y: 0, width: 340, height: 249 },
        params: { roundId },
      })),
    ];

    return {
      projectId: this.projectId,
      reportEntries: reportEntries.map(
        ({
          cardType,
          clip,
          params,
        }: {
          cardType: string;
          clip: Clip;
          params?: Record<string, number | string>;
        }) => {
          return {
            exportable: this.exportableType,
            variants: {
              shouldShowClientFacingNames: this.shouldShowClientFacingNames,
              roundIds: this.roundIds.join(','),
              buildingIds: this.buildingIds.join(','),
              floorIds: this.floorIds.join(','),
              category: this.category,
              cardType,
              ...params,
            },
            screenshotsOpts: [
              {
                format: this.format.toUpperCase(),
                width: 1020,
                clip,
              },
            ],
          } as ESAReportEntry;
        }
      ),
    };
  }
}
